import React from "react";
import filterFields from "../../../filterFields";

const defaultProps = {
    schemas: []
}

function OutputPointer({field, fields, object, target, schemas, indexes}) {
    const schema = schemas.find(s => s.collection === target) || {};
    const _fields = fields || schema.fields || {};
    const defaultIndexes = React.useMemo(() => {
        const items = filterFields(_fields, "_index");
        return items.length > 0 ? items : ['name'];
    }, [_fields]);
    const _indexes = indexes || defaultIndexes;

    const pointer = object[field];
    if (pointer) {
        return _indexes.map((index) => pointer[index]).join(' ');
    }
    return null;
}

OutputPointer.defaultProps = defaultProps;
export default OutputPointer;
